import { IUseLoginInfoReturnValue, ILoginParams } from './models';

/**
 * Allow all except @ before and after @ char and all expect @ as TLD after . char
 */
export const emailRegexp = /^[^@]+@[^@]+\.[^@]{2,}$/;

export const getSearchParams = (location: Location) => {
  const params = new URLSearchParams(location.search);
  return {
    clientId: params.get('client_id') || '',
    redirectTo: params.get('redirect_to') || '',
    scope: params.get('scope') || '',
    state: params.get('state') || '',
  };
};

export const buildSamlRelayState = ({
  clientId,
  redirectTo,
  scope,
  state,
}: ILoginParams) =>
  encodeURIComponent(
    new URLSearchParams({
      client_id: clientId, // eslint-disable-line @typescript-eslint/camelcase
      redirect_to: redirectTo, // eslint-disable-line @typescript-eslint/camelcase
      new_user_redirect_to: `${redirectTo}/join`, // eslint-disable-line @typescript-eslint/camelcase
      scope,
      ...(state && { state }),
    }).toString()
  );

export const buildMagicLinkQueryString = ({
  clientId,
  email,
  redirectTo,
  scope,
  state,
}: ILoginParams & { email: string }) =>
  new URLSearchParams({
    client_id: clientId, // eslint-disable-line @typescript-eslint/camelcase
    email,
    redirect_to: redirectTo, // eslint-disable-line @typescript-eslint/camelcase
    scope,
    state,
  }).toString();

export const getSsoUrl = (ssoEndpoint: string, params: ILoginParams) =>
  `${ssoEndpoint}?RelayState=${buildSamlRelayState(params)}`;

export const getVisibleButton = ({ data }: IUseLoginInfoReturnValue) => {
  let nextVisibleButton: undefined | 'sso' | 'magicLink' = undefined;

  if (data) {
    if (data.sso.enabled) {
      nextVisibleButton = 'sso';
    } else if (data.magicLinkSigninEnabled) {
      nextVisibleButton = 'magicLink';
    }
  }

  return nextVisibleButton;
};

/**
 * Memoizes previous provider name to prevent it changing
 * to undefined when new login info is being fetched
 */
export const getSsoProviderName = (() => {
  let previousName = '';
  return (loginInfo: IUseLoginInfoReturnValue) => {
    const newName = loginInfo.data
      ? loginInfo.data.sso.providerName
      : previousName;
    if (newName) {
      previousName = newName;
    }
    return newName;
  };
})();
